import { render, staticRenderFns } from "./PaperFormTable.vue?vue&type=template&id=3ff8f398&scoped=true"
import script from "./PaperFormTable.vue?vue&type=script&lang=js"
export * from "./PaperFormTable.vue?vue&type=script&lang=js"
import style0 from "./PaperFormTable.vue?vue&type=style&index=0&id=3ff8f398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff8f398",
  null
  
)

export default component.exports